import ZoomableMediaContainer from './ZoomableMediaContainer';

/**
 * Thin wrapper around ZoomableMediaContainer that renders an image.
 *
 * @param {src} String the image src
 * @returns a zoomable image component
 */

export default function ZoomableImage({ src }) {
    return (
        <ZoomableMediaContainer>
            {({ setAspectRatio, mediaIsLoaded, setMediaIsLoaded, centerView }) => {
                return (
                    <img
                        onLoad={event => handleMediaLoaded(event, setAspectRatio, setMediaIsLoaded, centerView)}
                        style={{
                            userSelect: 'none',
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain',
                            pointerEvents: 'none',
                            visibility: mediaIsLoaded ? 'visible' : 'hidden'
                        }}
                        src={src}
                    />
                );
            }}
        </ZoomableMediaContainer>
    );
}

// Once media is loaded, set the aspect ratio of the transform parent and set media is loaded to true
const handleMediaLoaded = (event, setAspectRatio, setMediaIsLoaded, centerView) => {
    centerView(1, 0);
    setMediaIsLoaded(true);
};
